import styled from "styled-components";

export const StyledTotalItem = styled.div`
    font-family: var(--bllink-font-primary);
    font-size: 18px;
    padding-bottom: 50px;
    margin-bottom: 17px;
    border-bottom: 1px solid #F3F1FF;
    display: flex;
    flex-direction: column;
    gap: 9px;
  
    .loaned {
      font-style: italic;
    }
    
    .line {
        display: flex;
        justify-content: space-between;
        height: 38px;
        align-items: center;
        
        .line-name {
            color: rgba(55, 54, 71, 0.7);
        }

        .currency-value {
            font-weight: 700;
        }
    }
`
